module.exports = __webpack_public_path__ + "static/media/intro.10a39419.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Dental Health/intro.jpg
// module id = 308
// module chunks = 0